export default {
  path: '/2019ShangyouAnswerRanking',
  name: 'ShangyouAnswerRanking2019',
  component: () => import('./home.vue'),
  base: '/2019ShangyouAnswerRanking/',
  meta: {
    title: '上游新闻答人排行榜',
  },
  children: [
    {
      path: 'RankingList',
      component: () => import('./RankingList.vue'),
      name: '2019ShangyouAnswerRankingRankingList',
      meta: {
        title: '上游新闻答人排行榜',
      },
    },
    {
      path: 'Register',
      component: () => import('./Register.vue'),
      name: '2019ShangyouAnswerRankingRegister',
      meta: {
        title: '上游新闻答人排行榜',
      },
    },
    {
      path: 'Prize',
      component: () => import('./Prize.vue'),
      name: '2019ShangyouAnswerRankingPrize',
      meta: {
        title: '上游新闻答人排行榜',
      },
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: '2019ShangyouAnswerRankingRules',
      meta: {
        title: '上游新闻答人排行榜',
      },
    },
  ],
};
